<template>
<div>
    <v-xevmosevm v-if="chainId == 9001"></v-xevmosevm>
    <v-xevmosevmtest v-if="chainId == 9000"></v-xevmosevmtest>
    <v-xevmoszk v-if="chainId == 280"></v-xevmoszk>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId') || 9001
            if(this.chainId != 9001){
                localStorage.setItem('chainId',9001)
                window.location.reload();
            }
        },
    }
</script> 